module.exports = __webpack_public_path__ + "assets/img/a1fa-na.svg";